/* Change log:
   * Base - 6/24/2014 version
         Added rule notEqual
         Added rule routingNumber
         Added rule ssn
         Added rule ZipInternational
         Added rule CommonCalendar
         Added rule onlyNumber
         Added rule currency
         Added rule userID
         Added rule password
         Added rule onlyLetterNumberSp
         Added rule allowableUploadTypes
         Added rule lastname
         Added rule address
         Added rule sameCharacter
         Added rule currency2
         Added rule interestRate
         Added rule alphanumeric
  * Add imports for functions which were assumed to be loaded from elsewhere. -- Arthur 2025-09-23
*/

import { currencyValidation } from "@/common/validation/utils.js";


(function ($) {
    $.fn.validationEngineLanguage = function(){
    };
    $.validationEngineLanguage = {
        newLang: function(){
            $.validationEngineLanguage.allRules = {
                "required": { // Add your regex rules here, you can take telephone as an example
                    "regex": "none",
                    "alertText": "This field is required",
                    "alertTextCheckboxMultiple": "Please select an option",
                    "alertTextCheckbox": "This checkbox is required",
                    "alertTextDateRange": "Both date range fields are required"
                },
                "requiredInFunction": { 
                    "func": function(field, rules, i, options){
                        return (field.val() === "test") ? true : false;
                    },
                    "alertText": "Field must equal test"
                },
                "dateRange": {
                    "regex": "none",
                    "alertText": "Invalid ",
                    "alertText2": "Date Range"
                },
                "dateTimeRange": {
                    "regex": "none",
                    "alertText": "Invalid ",
                    "alertText2": "Date Time Range"
                },
                "minSize": {
                    "regex": "none",
                    "alertText": "Minimum ",
                    "alertText2": " characters required"
                },
                "maxSize": {
                    "regex": "none",
                    "alertText": "Maximum ",
                    "alertText2": " characters allowed"
                },
                "groupRequired": {
                    "regex": "none",
                    "alertText": "You must fill one of the following fields",
                    "alertTextCheckboxMultiple": "Please select an option",
                    "alertTextCheckbox": "This checkbox is required"
                },
                "min": {
                    "regex": "none",
                    "alertText": "Minimum value is "
                },
                "max": {
                    "regex": "none",
                    "alertText": "Maximum value is "
                },
                "range": {
                   "regex": "none",
                   "alertText": "Value must be between ",
                   "alertText2": " and ",
                   "alertTextNumeric": "Range can only contain numbers"
                },
                "past": {
                    "regex": "none",
                    "alertText": "Date prior to "
                },
                "future": {
                    "regex": "none",
                    "alertText": "Date past "
                },	
                "maxCheckbox": {
                    "regex": "none",
                    "alertText": "Maximum ",
                    "alertText2": " options allowed"
                },
                "minCheckbox": {
                    "regex": "none",
                    "alertText": "Please select ",
                    "alertText2": " options"
                },
                "equals": {
                    "regex": "none",
                    "alertText": "Fields do not match"
                },
                "notEqual": {
                   "regex": "none",
                   "alertText": "Fields must be different"
                },
                "creditCard": {
                    "regex": "none",
                    "alertText": "Invalid credit card number"
                },
                "routingNumber": {
                   "regex": "none",
                   "alertText": "Invalid routing number"
                },
                "userID": {
                   "regex": /^[a-zA-Z0-9\.@\-_\$!\*&#]{8,50}$/,
                   "alertText": "User Name must be 8 to 50 characters and contain only letters, numbers, and the following special characters: <br />at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &)."
                },
                "password": {
                   // TODO: MFA - Convert this to a function to validate as described in the alertText.
                   "regex": /^[a-zA-Z0-9\.@\-_\$!\*&#]{8,25}$/,
                   //"regex": /^(?=.{8,25}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/,
                   "alertText": "Select an 8 to 25 character password that contains at least 3 of the following 4 character groupings: <br />uppercase letters, lowercase letters, numbers, and the following special characters: <br />at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &)."
                },
                "passwordhint": {
                   "regex": /^[a-zA-Z0-9\s\.@\-_\$!\*&#]{1,100}$/,
                   "alertText": "Password Hint must be 1 to 100 characters and contain only letters, numbers, and the following special characters: <br />at sign, period, dash, underscore, exclamation, dollar sign, hash tag, asterisk, ampersand (@ . - _ ! $ # * &)."
                },
                "phone": {
                    // credit: jquery.h5validate.js / orefalo
                   "regex": /^([\+][0-9]{1,3}([ \.\-])?)?([\(][0-9]{1,6}[\)])?([0-9 \.\-]{1,32})(([A-Za-z \:]{1,11})?[0-9]{1,4}?)$/,
                   "alertText": "Phone number must be 10 numeric digits."
                },
                "maskedphone": {
                   "regex": /1?\s*\W?\s*([2-9][0-8][0-9])\s*\W?\s*([2-9][0-9]{2})\s*\W?\s*([0-9]{4})(\se?x?t?(\d*))?/,
                    "alertText": "Phone number must be 10 numeric digits."
                },
                "ssn": {
                   // ssn regex accepts dashes or spaces between the number groups.  It also disallows ssn's beginning
                   // with 000, 666, or between 900-999.  The middle group cannot be 00.  The last group cannot be 0000.
                   // "regex": /^(?!000)(?!666)(?!9[0-9][0-9])\d{3}[\- ]?(?!00)\d{2}[\- ]?(?!0000)\d{4}$/,
                  // new rule to allow ssn formats with 9 digits, but no restrictions on specific digits
                  "regex": /^\d{3}[\- ]?\d{2}[\- ]?\d{4}$/,
                   "alertText": "The SSN is invalid. A valid SSN is 9 numeric digits.<br />It may be entered with or without dashes."
                },
                "emailwNA": {
                   "regex": /^([nN]\/[aA])|(^[A-Za-z0-9][A-Za-z0-9._+-]{0,63}@(?:(?=[A-Za-z0-9-]{1,63}\.)[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*\.){1,8}[A-Za-z]{2,63}$)$/,
                   "alertText": "Email Address is invalid.  Enter N/A if you do not have an address." +
                        "<br />Examples of valid email addresses:" +
                        "<br />&nbsp;&nbsp;&nbsp;niceandsimple@example.com" +
                        "<br />&nbsp;&nbsp;&nbsp;john.smith@example.com" +
                        "<br />&nbsp;&nbsp;&nbsp;email-with-dashes@example.com"
                },
                "email": {
                   "regex": /^[A-Za-z0-9][A-Za-z0-9._+-]{0,63}@(?:(?=[A-Za-z0-9-]{1,63}\.)[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*\.){1,8}[A-Za-z]{2,63}$/,
                   "alertText": "Email Address is invalid." +
                        "<br />Examples of valid email addresses:" +
                        "<br />&nbsp;&nbsp;&nbsp;niceandsimple@example.com" +
                        "<br />&nbsp;&nbsp;&nbsp;john.smith@example.com" +
                        "<br />&nbsp;&nbsp;&nbsp;email-with-dashes@example.com"
                },
                "fullname": {
                    "regex":/^([a-zA-Z]+[\'\,\.\-]?[a-zA-Z ]*)+[ ]([a-zA-Z]+[\'\,\.\-]?[a-zA-Z ]+)+$/,
                    "alertText": "The name must be both first and last name.<br />&nbsp;&nbsp;&nbsp;Ex.: John Smith"
                },
                "firstname": {
                   "regex": /^[A-Za-z\-' ]*$/,
                   "alertText": "First name may only contain letters, hyphen, apostrophe, and space"
                },
                "lastname": {
                   "regex": /^[A-Za-z\-' ]*$/,
                   "alertText": "Last name may only contain letters, hyphen, apostrophe, and space"
                },
                "address": {
                   "regex": /^([a-zA-Z0-9\.\-\ \/\#\\'])+$/,
                   "alertText": "Address may contain only letters, numbers, period, dash, space, slashes and pound sign."
                },
                "city": {
                   "regex": /^[a-zA-Z][' ]?([a-zA-Z\-\.]|[a-zA-Z\-\.] )*[a-zA-Z\-\.]$/,
                   "alertText": "City name must start with a letter and can only contain letters, dashes, space and period characters."
                },
                "state": {
                   "regex": /^[a-zA-Z][' ]?([a-zA-Z\-\.]|[a-zA-Z\-\.] )*[a-zA-Z\-\.]$/,
                   "alertText": "State must start with a letter and can only contain letters, dash, space and period characters."
                },
                "province": {
                   "regex": /^[a-zA-Z][' ]?([a-zA-Z\-\.]|[a-zA-Z\-\.] )*[a-zA-Z\-\.]$/,
                   "alertText": "Province must start with a letter and can only contain letters, dash, space and period characters." 
                },
                "zip": {
                   "regex":/^\d{5}(-)?(\d{4})?$/,
                   "alertText": "Zip code must be 5 or 9 digits. Such as:<br />&nbsp;&nbsp;63005" +
                      "<br />&nbsp;&nbsp;63005-1243"
                },
                "zipInternational": {
                   "regex": /^[a-zA-Z0-9\-#] ?([a-zA-Z0-9\-#]|[a-zA-Z0-9\-#] )*[a-zA-Z0-9\-#]$/,
                   "alertText": "Zip/Postal code may only contain letters, numbers, dash, pound sign and space characters."
                },
                "integer": {
                    "regex": /^[\-\+]?\d+$/,
                    "alertText": "Not a valid integer"
                },
                "number": {
                    // Number, including positive, negative, and floating decimal. credit: orefalo
                    "regex": /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
                    "alertText": "Invalid floating decimal number"
                },
                "commonCalendar": {
                   "regex": "none",
                   "alertText": "Please enter a date within",
                   "alertText1": "beginning on or after",
                   "alertText2": "(excluding weekends and Holidays)",
                   "alertText3": "(excluding weekends)",
                   "alertText4": "(excluding holidays)",
                   "alertText5": "Please enter a date"
                },
                "allowableUploadTypes" : {
                   "regex": /^.+\.((jpg)|(JPG)|(gif)|(GIF)|(jpeg)|(JPEG)|(pdf)|(PDF)|(bmp)|(BMP)|(txt)|(TXT))$/,
                   "alertText": "Only the following file types are allowed: .jpg, .gif, .pdf, .txt, .bmp"
                },
                "date": {                    
                    //	Check if date is valid by leap year
                  "func": function (field) {
                     var pattern = new RegExp(/^(\d{4})[\/\-\.](0?[1-9]|1[012])[\/\-\.](0?[1-9]|[12][0-9]|3[01])$/);
                     var match = pattern.exec(field.val());
                     if (match == null)
                        return false;
   
                     var year = match[1];
                     var month = match[2]*1;
                     var day = match[3]*1;					
                     var date = new Date(year, month - 1, day); // because months starts from 0.
   
                     return (date.getFullYear() == year && date.getMonth() == (month - 1) && date.getDate() == day);
                  },                		
                  "alertText": "Invalid date, must be in YYYY-MM-DD format"
                },
                "ipv4": {
                    "regex": /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
                    "alertText": "Invalid IP address"
                },
                "url": {
                    "regex": /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
                    "alertText": "Invalid URL"
                },
                "onlyNumberSp": {
                    "regex": /^[0-9\ ]+$/,
                    "alertText": "Enter only numbers or space"
                },
                "decimal":{
                   "regex": /^[0-9.]+$/,
                   "alertText": "Enter decimal numbers only"
                },
                "onlyNumber": {
                   "regex": /^[0-9]+$/,
                   "alertText": "Enter numbers only"
                },
                "onlyLetterSp": {
                    "regex": /^[a-zA-Z\ \']+$/,
                    "alertText": "Enter letters only"
                },
                "onlyLetterNumber": {
                    "regex": /^[0-9a-zA-Z]+$/,
                    "alertText": "Enter only letters or numbers.  <br/>No punctuation or special characters allowed."
                },
                "onlyLetterNumberSp": {
                   "regex": /^[A-Za-z0-9 ]*$/,
                   "alertText": "Enter only letters, numbers, or space.  <br />No punctuation or special characters allowed."
                },
                "sameCharacter": {
                   "regex": /^(.)\1+$/,
                   "alertText": "Value cannot be all the same character"
                },
                "currency": {
                   "func": function (field, rules, i, options) {
                      return currencyValidation(field, false);
                   },
                   "alertText": "The format of the amount entered is invalid.  Please use the 0.00 format for currency amounts.",
                   "alertTextNonZero": "Please enter a dollar amount."
                },
                "currency2": {
                   "func": function (field, rules, i, options) {
                      return currencyValidation(field, true);
                   },
                   "alertText": "The format of the amount entered is invalid.  Please use the 0.00 format for currency amounts.",
                   "alertTextNonZero": "Please enter a dollar amount."
                },
                "interestRate": {
                   "regex": /^\d*\.{0,1}\d+$/,
                   "alertText": "Please specify the interest rate."
                },
                "alphaNumeric": {
                   "regex": /^\w+[\w\s]*\w+$/,
                   "alertText": "Only Alpha numeric characters are allowed."
                },
                // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
                "ajaxUserCall": {
                    "url": "ajaxValidateFieldUser",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    "alertText": "This user is already taken",
                    "alertTextLoad": "Validating, please wait"
                },
            "ajaxUserCallPhp": {
                    "url": "phpajax/ajaxValidateFieldUser.php",
                    // you may want to pass extra data on the ajax call
                    "extraData": "name=eric",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "* This username is available",
                    "alertText": "This user is already taken",
                    "alertTextLoad": "Validating, please wait"
                },
                "ajaxNameCall": {
                    // remote json service location
                    "url": "ajaxValidateFieldName",
                    // error
                    "alertText": "This name is already taken",
                    // if you provide an "alertTextOk", it will show as a green prompt when the field validates
                    "alertTextOk": "This name is available",
                    // speaks by itself
                    "alertTextLoad": "Validating, please wait"
                },
             "ajaxNameCallPhp": {
                       // remote json service location
                       "url": "phpajax/ajaxValidateFieldName.php",
                       // error
                       "alertText": "This name is already taken",
                       // speaks by itself
                       "alertTextLoad": "Validating, please wait"
                   },
                "validate2fields": {
                    "alertText": "Please input HELLO"
                },
               //tls warning:homegrown not fielded 
                "dateFormat":{
                    "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(?:(?:0?[1-9]|1[0-2])(\/|-)(?:0?[1-9]|1\d|2[0-8]))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^(0?2(\/|-)29)(\/|-)(?:(?:0[48]00|[13579][26]00|[2468][048]00)|(?:\d\d)?(?:0[48]|[2468][048]|[13579][26]))$/,
                    "alertText": "Please enter the date in this format:  MM-DD-YYYY"
                },
                //tls warning:homegrown not fielded 
            "dateTimeFormat": {
                   "regex": /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1}$|^(?:(?:(?:0?[13578]|1[02])(\/|-)31)|(?:(?:0?[1,3-9]|1[0-2])(\/|-)(?:29|30)))(\/|-)(?:[1-9]\d\d\d|\d[1-9]\d\d|\d\d[1-9]\d|\d\d\d[1-9])$|^((1[012]|0?[1-9]){1}\/(0?[1-9]|[12][0-9]|3[01]){1}\/\d{2,4}\s+(1[012]|0?[1-9]){1}:(0?[1-5]|[0-6][0-9]){1}:(0?[0-6]|[0-6][0-9]){1}\s+(am|pm|AM|PM){1})$/,
                    "alertText": "Invalid Date or Date Format",
                    "alertText2": "Expected Format: ",
                    "alertText3": "mm/dd/yyyy hh:mm:ss AM|PM or ", 
                    "alertText4": "yyyy-mm-dd hh:mm:ss AM|PM"
               }
            };
            
        }
    };

    $.validationEngineLanguage.newLang();
    
})(jQuery);
